<template>
    <van-popup v-model:show="showPicker" destroy-on-close round position="bottom" :style="{ height: '50%' }">
        <van-picker
            v-model:selected-index="selectedIndex"
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
        />
    </van-popup>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { http } from '@/request/http'

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => []
    },
    cascade: {
        type: Boolean,
        default: true
    }
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const showPicker = ref(false)
const categoryList = ref([])
const selectedIndex = ref([])
const columns = ref([{text: '全部', value: ''}, {text: '未发布', value: 0}, {text: '待审核', value: 1}, {text: '审核失败', value: 2}, {text: '审核成功', value: 3}, {text: '已发布', value: 4}, {text: '已下架', value: 5}])

const openPicker = () => {
    showPicker.value = true
}

const onConfirm = ({ selectedOptions }) => {
    showPicker.value = false
    emit('update:modelValue', selectedOptions.map(opt => ({
        id: opt.value,
        name: opt.text
    })))
    emit('confirm', selectedOptions.map(opt => ({
        id: opt.value,
        name: opt.text
    })))
}



watch(showPicker, (val) => {
    if (val && categoryList.value.length === 0) {

    }
})

defineExpose({
    openPicker
})
</script>
